import { Button, Paper, Stack, Text, TextInput, Title } from '@mantine/core';
import { IconMailCheck } from '@tabler/icons-react';
import { useState, type FormEvent } from 'react';
import { api, izvedi } from '../api/odjemalec';
import { NapakaApi, sporocilo } from '../api/napaka';
import { TemnoOzadje } from '../postavitev/TemnoOzadje';
import { NapakaVstopa, NazajNaPrijavo } from './vstop';

/**
 * Pozabljeno geslo: uporabniško ime ali e-pošta → povezava za novo geslo na e-pošto. Odgovor je vedno enak (strežnik ne
 * pove, ali račun obstaja); uporabniki brez e-pošte se obrnejo na skrbnika v podjetju.
 */
export function PozabljenoGeslo() {
  const [uporabnik, setUporabnik] = useState('');
  const [napakaPolja, setNapakaPolja] = useState<string | undefined>();
  const [napaka, setNapaka] = useState<string | null>(null);
  const [dela, setDela] = useState(false);
  const [poslano, setPoslano] = useState(false);

  const oddaj = async (e: FormEvent) => {
    e.preventDefault();
    setDela(true);
    setNapakaPolja(undefined);
    setNapaka(null);
    try {
      await izvedi(api.POST('/api/geslo/pozabljeno', { body: { uporabnik } }));
      setPoslano(true);
    } catch (e) {
      if (e instanceof NapakaApi && e.polja.uporabnik) {
        setNapakaPolja(e.polja.uporabnik);
      } else {
        setNapaka(sporocilo(e));
      }
    } finally {
      setDela(false);
    }
  };

  return (
    <TemnoOzadje>
      <Paper radius="lg" p={36} shadow="xl">
        {poslano ? (
          <Stack gap="md">
            <IconMailCheck size={40} stroke={1.5} />
            <Title order={2} size="h3">
              Preverite e-pošto
            </Title>
            <Text size="sm">
              Če račun <b>{uporabnik.trim()}</b> obstaja in ima e-poštni naslov, smo nanj poslali povezavo za novo
              geslo. Povezava velja eno uro.
            </Text>
            <Text size="sm" c="dimmed">
              Sporočila ni? Preverite mapo z neželeno pošto. Če vaš račun nima e-pošte, vam geslo ponastavi skrbnik v
              vašem podjetju (Nastavitve → Uporabniki).
            </Text>
            <NazajNaPrijavo />
          </Stack>
        ) : (
          <form onSubmit={(e) => void oddaj(e)} noValidate>
            <Stack gap="md">
              <div>
                <Title order={2} size="h3">
                  Pozabljeno geslo
                </Title>
                <Text size="sm" c="dimmed">
                  Vpišite uporabniško ime ali e-poštni naslov. Poslali vam bomo povezavo za novo geslo.
                </Text>
              </div>
              <TextInput
                label="Uporabniško ime ali e-pošta"
                value={uporabnik}
                onChange={(e) => setUporabnik(e.currentTarget.value)}
                error={napakaPolja}
                autoComplete="username"
                autoFocus
              />
              {napaka && <NapakaVstopa>{napaka}</NapakaVstopa>}
              <Button type="submit" fullWidth loading={dela}>
                Pošlji povezavo
              </Button>
              <NazajNaPrijavo />
            </Stack>
          </form>
        )}
      </Paper>
    </TemnoOzadje>
  );
}
